import { useCallback, useRef } from 'react';
import { bankByIban, normalizeIban } from '../constants/kzBanks';

/**
 * ÐÐ¾Ð´ÑÑÐ°Ð²Ð»ÑÐµÑ Ð±Ð°Ð½Ðº Ð¸ ÐÐÐ Ð¿Ð¾ Ð²Ð²ÐµÐ´ÑÐ½Ð½Ð¾Ð¼Ñ IBAN: ÐºÐ¾Ð´ Ð±Ð°Ð½ÐºÐ° ÑÐ¸Ð´Ð¸Ñ Ð² ÑÐ°Ð¼Ð¾Ð¼ Ð½Ð¾Ð¼ÐµÑÐµ
 * ÑÑÑÑÐ° (Ð·Ð½Ð°ÐºÐ¸ 5â7), Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð½ÐµÑ ÑÐ¼ÑÑÐ»Ð° Ð¸ÑÐºÐ°ÑÑ ÑÑÐ¸ ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÑÑÐºÐ°Ð¼Ð¸.
 *
 * ÐÐ¾Ð·Ð²ÑÐ°ÑÐ°ÐµÑ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÑÐ¸Ðº Ð´Ð»Ñ onValuesChange ÑÐ¾ÑÐ¼Ñ. ÐÐ¾Ð´ÑÑÐ°Ð²Ð»ÐµÐ½Ð½Ð¾Ðµ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¼Ð¾Ð¶ÐµÑ
 * Ð¿Ð¾Ð¿ÑÐ°Ð²Ð¸ÑÑ â Ð¸ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð½Ð¾Ðµ Ð¼Ñ Ð±Ð¾Ð»ÑÑÐµ Ð½Ðµ ÑÑÐ¾Ð³Ð°ÐµÐ¼, Ð´Ð°Ð¶Ðµ ÐµÑÐ»Ð¸ IBAN Ð¿Ð¾ÑÐ¾Ð¼ Ð¿Ð¾Ð¼ÐµÐ½ÑÑÑ.
 *
 * @param {Object} formRef â ref Ð½Ð° HookForm (Ð½ÑÐ¶ÐµÐ½ ÐµÐ³Ð¾ setValue)
 * @param {Object} fields â Ð¸Ð¼ÐµÐ½Ð° Ð¿Ð¾Ð»ÐµÐ¹, ÐµÑÐ»Ð¸ Ð¾Ð½Ð¸ Ð¾ÑÐ»Ð¸ÑÐ°ÑÑÑÑ Ð¾Ñ iban/bankName/bic
 */
const useIbanAutofill = (formRef, { iban = 'iban', bank = 'bankName', bic = 'bic' } = {}) => {
  const applied = useRef({ iban: null, bank: null, bic: null });

  return useCallback(
    (values) => {
      const current = normalizeIban(values?.[iban]);
      // setValue Ð½Ð¸Ð¶Ðµ ÑÐ½Ð¾Ð²Ð° Ð´ÑÑÐ½ÐµÑ onValuesChange â Ð²ÑÑÐ¾Ð´Ð¸Ð¼, Ð¿Ð¾ÐºÐ° ÑÑÑÑ ÑÐ¾Ñ Ð¶Ðµ.
      if (current === applied.current.iban) return;

      const found = bankByIban(current);
      if (!found) {
        applied.current = { iban: current, bank: null, bic: null };
        return;
      }

      const form = formRef?.current;
      if (!form) return;

      const bankValue = values?.[bank];
      const bicValue = values?.[bic];
      if (!bankValue || bankValue === applied.current.bank) form.setValue(bank, found.name);
      if (!bicValue || bicValue === applied.current.bic) form.setValue(bic, found.bic);

      applied.current = { iban: current, bank: found.name, bic: found.bic };
    },
    [formRef, iban, bank, bic]
  );
};

export default useIbanAutofill;
